import Post from './app-post'
export default Post;